/**
 * JasrLogo — The bridge icon for Jasr platform.
 * Two nodes connected by an elegant arc.
 */
export function JasrMark({ size = 40, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Glow filter */}
      <defs>
        <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feMerge><feMergeNode in="blur"/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
        <linearGradient id="arc-grad" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#60A5FA" />
          <stop offset="50%" stopColor="#FFFFFF" stopOpacity="0.95" />
          <stop offset="100%" stopColor="#818CF8" />
        </linearGradient>
      </defs>
      {/* Left node */}
      <circle cx="8" cy="26" r="4.5" fill="#004EEB" filter="url(#glow)" />
      <circle cx="8" cy="26" r="2.5" fill="#60A5FA" />
      {/* Right node */}
      <circle cx="32" cy="26" r="4.5" fill="#6366F1" filter="url(#glow)" />
      <circle cx="32" cy="26" r="2.5" fill="#818CF8" />
      {/* Bridge arc */}
      <path
        d="M 8 26 C 8 8, 32 8, 32 26"
        stroke="url(#arc-grad)"
        strokeWidth="2.5"
        strokeLinecap="round"
        filter="url(#glow)"
      />
      {/* Center highlight dot */}
      <circle cx="20" cy="9.5" r="2.2" fill="white" opacity="0.85" />
    </svg>
  );
}

export function JasrWordmark({ light = false, size = "md" }) {
  const sizes = { sm: "text-base", md: "text-xl", lg: "text-2xl", xl: "text-4xl" };
  return (
    <span
      className={`font-black tracking-tight ${sizes[size]} ${light ? "text-white" : "text-slate-900"}`}
      style={{ fontFamily: "'Tajawal', sans-serif" }}
    >
      جسر
      <span className="text-[#004EEB]">.</span>
    </span>
  );
}

export function JasrBrand({ light = false, showTagline = false }) {
  return (
    <div className="flex items-center gap-3">
      <div className="w-9 h-9 bg-[#004EEB] rounded-xl grid place-items-center shadow-[0_0_20px_rgba(0,78,235,0.4)] shrink-0">
        <JasrMark size={28} />
      </div>
      <div className="leading-tight">
        <JasrWordmark light={light} size="md" />
        {showTagline && (
          <div className={`text-[10px] tracking-[0.08em] mt-0.5 ${light ? "text-white/35" : "text-slate-400"}`}>
            جسر ذكي بين أنظمتك
          </div>
        )}
      </div>
    </div>
  );
}
